import { useMutation } from "react-query";
import { authLoginMicelu } from "./auth-micelu-service";
import { IAuthLoginAgensService } from "./use-auth-micelu.interface";

export const useAuthLoginAgents = () => {
  return useMutation((data: IAuthLoginAgensService) => authLoginMicelu(data));
};
